import ConfigWidgetLabel from 'scoreboard/dashboards/widgets/config-widget-label'
import defaultDataSourceLabel from 'scoreboard/dashboards/widgets/default-data-source-label'

/**
 * Dialog view for the Set Title option in the shape widget's config menu.
 *
 * Note: this class is uses "label" in its naming, because "label" is the
 * equivalent property name we use in all other widgets. But "Title" is the
 * terminology we use in the UI.
 */
const ShapeLabelConfigView = ConfigWidgetLabel.extend({
	dialogTitle: 'dashboards.setTitle',

	_getModelLabel: function () {
		return this.model.properties.get('label')
	},

	_setModelLabel: function (label) {
		this.options.widgetUpdater.setProperties({ label })
	},

	_getSuggestion: function () {
		return defaultDataSourceLabel(this.model)
	}
})

export default ShapeLabelConfigView

ShapeLabelConfigView.__filename__ = 'dashboards/widgets/shape/config/shape-label-config-view.js'
